module.exports = __webpack_public_path__ + "img/مسکات.c18f678e.png";